import { zObj, zStr, zAny } from "../zodWrapper.js";
export const Message = zObj({
    typeName: zStr(),
    data: zAny(),
});
export const SignInKey = zObj({
    key: zStr(),
});
export const Notification = zObj({
    text: zStr(),
});
//# sourceMappingURL=messageTypeSchemas.js.map